import { render } from "./NewWaterPoint.vue?vue&type=template&id=e6591b9a&scoped=true"
import script from "./NewWaterPoint.vue?vue&type=script&lang=js"
export * from "./NewWaterPoint.vue?vue&type=script&lang=js"

import "./NewWaterPoint.vue?vue&type=style&index=0&id=e6591b9a&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6591b9a"],['__file',"src/components/waterpoint/NewWaterPoint.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e6591b9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e6591b9a', __exports__)) {
    console.log('reload')
    api.reload('e6591b9a', __exports__)
  }
  
  module.hot.accept("./NewWaterPoint.vue?vue&type=template&id=e6591b9a&scoped=true", () => {
    console.log('re-render')
    api.rerender('e6591b9a', render)
  })

}


export default __exports__